import { Button, Tooltip } from "@mui/material";

interface Props {
  handleResetFilters: VoidFunction;
}

export function ResetFiltersButton(props: Props) {
  const { handleResetFilters } = props;

  return (
    <Tooltip title="Reset all filter selections to their default values">
      <Button color="error" onClick={handleResetFilters}>
        Reset Filters
      </Button>
    </Tooltip>
  );
}
